import { render, staticRenderFns } from "./Chefs.vue?vue&type=template&id=7dbcb316&"
import script from "./Chefs.vue?vue&type=script&lang=js&"
export * from "./Chefs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports